// common
export const PUT_REQUEST = 'consultationCase/PUT_REQUEST'
export const PUT_SUCCESS = 'consultationCase/PUT_SUCCESS'
export const PUT_FAILURE = 'consultationCase/PUT_FAILURE'
export const GET_CASE_RELATED_REQUEST = 'consultationCase/GET_CASE_RELATED_REQUEST'
export const GET_CASE_RELATED_SUCCESS = 'consultationCase/GET_CASE_RELATED_SUCCESS'
export const GET_CASE_RELATED_FAILURE = 'consultationCase/GET_CASE_RELATED_FAILURE'

export const UPDATE_CASE_RELATE_LIST = 'consultationCase/UPDATE_CASE_RELATE_LIST'